import React from 'react'
import SecondBanner from '../components/Banner/SecondBanner'
import IndustryPage from '../components/Industries/industries'

const industries = () => {
  return (
    <>
    <SecondBanner title="Industries" breadcrumbText="Industries" />
    <IndustryPage/>
    </>
  )
}

export default industries